import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'svc-toyota-declined-reason-dialog',
  templateUrl: './toyota-declined-reason-dialog.component.html',
  styleUrls: ['./toyota-declined-reason-dialog.component.css']
})
export class ToyotaDeclinedReasonDialogComponent implements OnInit {

  selectedDeclinedReason: any;

  constructor(
    public dialogRef: MatDialogRef<ToyotaDeclinedReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {}

  onCancel(): void {
    this.dialogRef.close({ cancelled: true, selectedDeclinedReason: null });
  }

  onConfirm(selectedDeclinedReason: any): void {
    this.dialogRef.close({ cancelled: false, selectedDeclinedReason: selectedDeclinedReason });
  }

}
